import { render, staticRenderFns } from "./ViewWarehousePage.vue?vue&type=template&id=63d71a5c"
import script from "./ViewWarehousePage.vue?vue&type=script&lang=js"
export * from "./ViewWarehousePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports